import { render, staticRenderFns } from "./TsoftKategori.vue?vue&type=template&id=de649158&scoped=true"
import script from "./TsoftKategori.vue?vue&type=script&lang=js"
export * from "./TsoftKategori.vue?vue&type=script&lang=js"
import style0 from "./TsoftKategori.vue?vue&type=style&index=0&id=de649158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de649158",
  null
  
)

export default component.exports